import React from "react";

import data from "../data/hero.json";

const Herov2 = ({ isBg }) => {
  const { herov2 } = data;

  return (
    <section
      id="hero"
      className={`hero hero__padding overflow-hidden position-relative ${isBg === "yes" ? "bg-one" : ""
        }`}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-7 col-lg-6 m-0px-b md-m-40px-b">
            <div className="hero__content position-relative">
              <h1 className="display-4 mb-4 text-capitalize">{herov2.title}</h1>
              <h4>{herov2.subtitle}</h4>
              <p className="text-muted mb-5 fs-5" dangerouslySetInnerHTML={{ __html: herov2.description }}></p>
              <div>
                <a
                  href={herov2.buyLink}
                  target="_blank"
                  rel="noreferrer"
                  className="smooth button button__primary me-3"
                >
                  <span>{herov2.buyBtn}</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-5 offset-lg-1 text-center">
            <div className="hero__images3">
              <img
                width="400"
                className="img-fluid"
                src={herov2.image}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Herov2;
